export const ELIGIBLE_STORAGE_RATIO_THRESHOLD_TO_SEE_MODAL = 1;
